"use strict";
exports.__esModule = true;
exports.ContactDocument = void 0;
var ContactDocument = /** @class */ (function () {
    function ContactDocument(data) {
        Object.assign(this, data); // Dynamically assign properties
    }
    ContactDocument.fromJSON = function (json) {
        var contact = new ContactDocument({});
        if (json) {
            Object.assign(contact, json);
        }
        return contact;
    };
    return ContactDocument;
}());
exports.ContactDocument = ContactDocument;
